import React from "react";

import { Flex, Layout, Typography } from "antd";

interface AppShellHeaderProps {
  title: React.ReactNode;
  centerContent?: React.ReactNode;
  actions?: React.ReactNode;
}

const renderTitle = (title: React.ReactNode) => {
  if (React.isValidElement(title)) {
    return title;
  }

  return (
    <Typography.Title
      level={4}
      style={{
        margin: 0,
        color: "#FFFFFF",
        fontSize: 20,
        fontWeight: 600,
        lineHeight: 1,
      }}
    >
      {title}
    </Typography.Title>
  );
};

export const AppShellHeader: React.FC<AppShellHeaderProps> = ({
  title,
  centerContent,
  actions,
}) => {
  return (
    <Layout.Header
      style={{
        height: 56,
        paddingInline: 24,
        background: "#000000",
        borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      <Flex align="center" gap={16} style={{ height: "100%", width: "100%" }}>
        <Flex
          align="center"
          style={{ flex: "0 1 auto", minWidth: 0, overflow: "hidden" }}
        >
          {renderTitle(title)}
        </Flex>
        <Flex
          align="center"
          justify="center"
          style={{ flex: "1 1 auto", minWidth: 0, overflow: "hidden" }}
        >
          {centerContent}
        </Flex>
        <Flex
          align="center"
          justify="flex-end"
          gap={8}
          style={{ flex: "0 0 auto", minWidth: 0 }}
        >
          {actions}
        </Flex>
      </Flex>
    </Layout.Header>
  );
};
